import classnames from 'classnames'

import Select from '@components/Select'
import { withFormsy } from 'formsy-react'
import ValidationError from '@components/ValidationError'

// atm react-select lib doesn't support `required` prop
// https://github.com/JedWatson/react-select/issues/3140

const RequiredSelectWithFormsy = ({
    value,
    setValue,
    onChange,
    getSelectValue,
    name,
    required = true,
    ariaLabel,
    errorMessage,
    isValid,
    isFormSubmitted,
    showSubmitErrors,
    className,
    ...props
}) => {
    // react-select has no blur based error state of its own, so the error only shows up once
    // the customer has attempted to submit the form
    const hasError = (isFormSubmitted || showSubmitErrors) && !isValid

    const onChangeHandler = option => {
        setValue(option.value)
        onChange && onChange(option.value)
    }

    return (
        <>
            <Select
                {...props}
                className={classnames(className, { 'select--error': hasError })}
                value={getSelectValue(value)}
                onChange={onChangeHandler}
                aria-label={ariaLabel}
            />
            <input
                id={name}
                aria-label={name}
                autoComplete="off"
                className="hidden-input"
                name={name}
                value={getSelectValue(value) ? value : ''}
                required={required}
            />
            {hasError && <ValidationError>{errorMessage || <T>input.required.error.message</T>}</ValidationError>}
        </>
    )
}

export default withFormsy(RequiredSelectWithFormsy)
